module.exports = __webpack_public_path__ + "img/google.57ecd411.svg";